(function () {
  'use strict';
  angular.module('dso')
    .component('locationsTemplateGrid', {
        bindings: {
          readOnly: '@',
          dsoId: '@',
          inUserView: '=',
          isApprover: '@',
          uploadedDocument: '<',
          onDelete: '&',
          onCompletion: '&'
        },
        controller: ['MyDso', 'Dso', '$scope', '$uibModal', '$window', 'FileSaver',
            function(MyDso, Dso, $scope, $uibModal, $window, FileSaver) {
          var ctrl = this;
          ctrl.locationsTemplateGridOptions = {
            enableSorting: true,
            enableColumnResizing: true,
            enableRowHeaderSelection: false,
            exporterMenuPdf: false,
            enableGridMenu: true,
            onRegisterApi: function(api) {
              ctrl.locationsGridApi = api;
            },
            appScopeProvider: {
              deleteRow : (row) => {
                ctrl.confirmDelete(row);
              },
              downloadFile : (row) => {
                ctrl.downloadFile(row);
              },
              markCompleted : (row) => {
                ctrl.markCompleted(row);
              }
            },
            columnDefs: [
              { name: 'File', width: '55%', sort: { priority: 0 },
                cellTemplate: '<span style="margin-left: 5px"><a href ng-click="grid.appScope.downloadFile(row)">{{row.entity.filename}}</a></span>'
              },
              { field: 'status', displayName: 'Status', width: '20%', cellFilter: 'templateStatus'}
            ]
          };
          function getDsoDocuments() {
            ctrl.running = true;
            var params = ctrl.isApprover ? {id: ctrl.dsoId} : '';
            return ctrl.dsoFactory.getDsoDocuments(params,function(data) {
              ctrl.running = false;
              ctrl.locationsTemplateGridOptions.data = (data && data.documents) ? data.documents : [];
            },function(error){
               ctrl.running = false;
               throw error;
            });
          }
          this.$onInit = function (){
            ctrl.dsoFactory = ctrl.isApprover ? Dso : MyDso();
            getDsoDocuments();
            if (ctrl.isApprover) {
                ctrl.locationsTemplateGridOptions.columnDefs.push({ name: 'Download/Mark Completed',
                    cellTemplate: '<span class="multiTaxId">&nbsp; ' +
                                    '<a href ng-click="grid.appScope.downloadFile(row)" ng-if="row.entity.status==\'PENDING_LOCATIONS_APPROVAL\'"><i class="fa fa-arrow-circle-down fa-lg" aria-hidden="true" title="Download"></i></a>' +
                                    '<a href ng-click="grid.appScope.markCompleted(row)" ng-if="row.entity.status==\'PROCESSING\'"><i class="fa fa-check-circle fa-lg" aria-hidden="true" title="Mark completed"></i></a>' +
                                    '</span>'
                });
            }else{
                ctrl.locationsTemplateGridOptions.columnDefs.push({ name: 'Delete',
                    cellTemplate: '<span class="multiTaxId"><a href ng-click="grid.appScope.deleteRow(row)"" ng-show="row.entity.status==\'PENDING_LOCATIONS_APPROVAL\'"><i class="fa fa-minus-circle fa-lg" aria-hidden="true"></i></a></span>' });
            }
          };
          this.$onChanges = function(changedObj) {
            var uploadedDocument = _.pick(changedObj, 'uploadedDocument');
            var newDocument = uploadedDocument.uploadedDocument ?  uploadedDocument.uploadedDocument.currentValue : undefined;
            if (newDocument) {
              _.remove(ctrl.locationsTemplateGridOptions.data, (row) => {
                return row.filename === newDocument.filename;
              });
              ctrl.locationsTemplateGridOptions.data.push(newDocument);
            }
          };
          ctrl.downloadFile = function(row) {
            ctrl.running = true;
            var params = ctrl.isApprover ? {id: ctrl.dsoId, documentId: row.entity.id} : {documentId: row.entity.id};
            ctrl.dsoFactory.getDsoDocument(params,function(data) {
              ctrl.running = false;
              FileSaver.saveAs(data.blob,data.filename);
              if (ctrl.isApprover && row.entity.status == 'PENDING_LOCATIONS_APPROVAL') {
                ctrl.acceptFile(row);
              }
            },function(error){
               ctrl.running = false;
               throw error;
            });
          };
          ctrl.acceptFile = function(row) {
            ctrl.running = true;
            ctrl.dsoFactory.acceptDsoDocument({id: ctrl.dsoId, data: row.entity},function(data) {
              ctrl.running = false;
              ctrl.locationsTemplateGridOptions.data[ctrl.locationsTemplateGridOptions.data.indexOf(row.entity)] = data;
            },function(error){
               ctrl.running = false;
               throw error;
            });
          };
          ctrl.markCompleted = function(row) {
            ctrl.running = true;
            ctrl.dsoFactory.dsoDocumentCompleted({id: ctrl.dsoId, data: row.entity},function(data) {
              ctrl.running = false;
              ctrl.locationsTemplateGridOptions.data[ctrl.locationsTemplateGridOptions.data.indexOf(row.entity)] = data;
              ctrl.onCompletion();
            },function(error){
               ctrl.running = false;
               throw error;
            });
          };
          ctrl.confirmDelete = function(row) {
              $uibModal.open({
                controller:['$uibModalInstance', '$scope', 'data', function($uibModalInstance, $scope, data) {
                  var self = this;
                  self.data = angular.copy(data);
                  self.entityName = self.data.row.filename;
                  $scope.$on('authenticationChanged', () => {
                    $uibModalInstance.dismiss();
                  });
                  self.delete = function() {
                    $uibModalInstance.close(true);
                  };
                  self.close = function() {
                    $uibModalInstance.dismiss();
                  };
                }],
                templateUrl: '/js/dso/confirmDelete.html' + appVersion,
                size: 'sm',
                animation: false,
                controllerAs: 'confirmation',
                resolve: {
                  data: function() {
                    return {
                      inUserView: ctrl.inUserView,
                      row: row.entity
                    };
                  }
                }
              }).result.then(function(val) {
                if (val) {
                  ctrl.running = true;
                  var params = ctrl.isApprover ? {id: ctrl.dsoId, data: row.entity} : {documentId: row.entity.id};
                  ctrl.dsoFactory.deleteDsoDocument(params,function(){
                    ctrl.running = false;
                    ctrl.locationsTemplateGridOptions.data.splice(ctrl.locationsTemplateGridOptions.data.indexOf(row.entity),1);
                    $scope.dnConfirmationMessage.$show(row.entity.filename +" has been deleted.");
                    ctrl.onDelete();
                  },function(error){
                    ctrl.running = false;
                    throw error;
                  });
                }
            }, angular.noop);
          };
        }],
        templateUrl: 'js/dso/locationsTemplateGrid.html' + appVersion
      }
    );
})();
